import { ChatHistoryDetails, Message, msgOf } from '@src/model/chat-bot';
import DOMPurify from 'dompurify';
import { marked } from 'marked';
import {CustomerStore} from '@src/components/store/customer.store';
import {UserStore} from '@src/components/store/user.store';

export const mapHistoryToMessages = (history: ChatHistoryDetails[]): Message[] =>
    history.flatMap(h => [msgOf.customer(h.inputRequest), msgOf.agent(h.responseText)]);

export function applyMarkdownFormatting(text: string): string {
    return marked.parse(text) as string;
}

export function sanitizeHtml(html: string): string {
    return DOMPurify.sanitize(applyMarkdownFormatting(html), { USE_PROFILES: { html: true } });
}

export function isChatBotEnable(customerStore: CustomerStore, userStore: UserStore): boolean {
    return !!(customerStore.selectedLocation?.serviceFeatures?.enableChatbot)
        && !(userStore.isReadOnlyUser && !userStore.isExternalUser);
}